import { connect } from 'react-redux';
import { logoutUser } from '../../actions.js';
import Logout from './logout.js';

export default connect(null, { logoutUser: logoutUser.requested })(Logout);
